import React from "react";

import Icon from "../../icons/Icon";
import StyledDivs from "../StyledDivs";

const Headroom = ({ extentions }) => {
    const headroom = extentions.find((item) => item.erw_typ_id === 1);
    let headroomText = headroom.erw_type_val
        .replace("x,xx", headroom.erw_value.replace(".", ","))
        .replace("nur ", "max. ");
    if (!headroom) {
        return null;
    }
    return (
        <StyledDivs.SubItemsWithIcon>
            <Icon iconName="headroom" />
            <StyledDivs.SubItems>
                <StyledDivs.SubItemHeadline>
                    Durchfahrtshöhe:
                </StyledDivs.SubItemHeadline>
                <div>{headroomText}</div>
            </StyledDivs.SubItems>
        </StyledDivs.SubItemsWithIcon>
    );
};

export default Headroom;
